/**
 * Mỗi phần tử = 1 dòng trong bảng hướng dẫn tải.
 * method: { line1, line2, nowrap } — nowrap=true bọc line2 bằng span để không xuống dòng.
 */
export const DOWNLOAD_TABLE_ROWS = [
  {
    linkId: 1,
    method: { line1: "Trực tiếp", line2: "", nowrap: false },
    instruction: "Chuột trái 2 lần tự cài đặt",
    accessCondition: "Không cần đăng nhập drive google",
    speed: "Bình thường",
    url: "https://secure.tinhnghiaxua.com/trikytrungphung_09_01_26.exe",
    note: "Nếu trình duyệt tải báo lỗi, sử dụng link 3 thay thế",
  },
  {
    linkId: 2,
    method: { line1: "Qua drive", line2: "", nowrap: true },
    instruction: "Chuột trái 2 lần tự cài đặt",
    accessCondition: "Đăng nhập drive google",
    speed: "Nhanh",
    url: "https://drive.google.com/file/d/19EhXQE2wl5dE_PzQ0IbykqsyTjFK3NlV/view?usp=sharing",
    note: "Nếu trình duyệt tải báo lỗi, sử dụng link 3 thay thế",
  },
  {
    linkId: 3,
    method: { line1: "Qua drive", line2: "", nowrap: true },
    instruction: "Giải nén file rar",
    accessCondition: "Đăng nhập drive google",
    speed: "Nhanh",
    url: "https://drive.google.com/file/d/1yBP-MP-jas5T_Aui6VSZQF3TjAK5d41_/view?usp=sharing",
    note: "Không có rar để giải nén, sử dụng link 1 hoặc 2 thay thế",
  },
];

/** Trả về danh sách dòng, có thể shuffle URL của 2 link đầu (tùy logic sau). */
export const getShuffledTableRows = () => {
  //const rows = DOWNLOAD_TABLE_ROWS.map((row) => ({ ...row }));
  //if (rows.length >= 2 && Math.random() < 0.5) {
  //  [rows[0].url, rows[1].url] = [rows[1].url, rows[0].url];
  //}
   return DOWNLOAD_TABLE_ROWS;
};
